import { memo, useRef, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { getInitialsFromEmail } from '../../utils/authUtils';
import UserDropdown from '../UserDropdown';

interface UserAvatarProps {
  size?: number;
  className?: string;
}

export const UserAvatar = memo(
  ({ size = 28, className = '' }: UserAvatarProps) => {
    const auth = useAuth();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const avatarRef = useRef<HTMLDivElement>(null);

    // Get user initials from the authenticated user profile
    const getUserInitials = () => {
      const user = auth.user;
      const profile = user?.profile;
      if (!profile) return 'U';

      const userFirstName = (profile.firstName as string) || '';
      const userLastName = (profile.lastName as string) || '';
      const email = profile.email || profile.preferred_username || '';
      const nameAbbr = userFirstName && userLastName
        ? `${userFirstName[0]}${userLastName[0]}`.toUpperCase()
        : getInitialsFromEmail(email);
      if(nameAbbr){
        return nameAbbr;
      }
      return 'U';
    };

    const toggleDropdown = () => {
      setIsDropdownOpen(!isDropdownOpen);
    };

    const initials = getUserInitials();

    return (
      <div className="relative">
        <div
          ref={avatarRef}
          className={`flex items-center justify-center rounded-full text-white font-semibold select-none cursor-pointer hover:opacity-80 transition-opacity duration-200 ${className}`}
          style={{
            width: size,
            height: size,
            fontSize: 12, // Scale font size relative to avatar size
            lineHeight: 1,
            background: '#000000',
          }}
          title={auth.user?.profile?.name || 'User'}
          onClick={toggleDropdown}>
          {initials}
        </div>

        <UserDropdown
          isOpen={isDropdownOpen}
          onClose={() => setIsDropdownOpen(false)}
          user={auth.user}
          avatarRef={avatarRef}
        />
      </div>
    );
  },
);

UserAvatar.displayName = 'UserAvatar';

export default UserAvatar;
